export default {"src":"/_next/static/media/PEPE.0d3c7b91.svg","height":50,"width":50,"blurWidth":0,"blurHeight":0};